const temaLight = {
  corPrincipal: '#2b2a35',
  corSecundaria: '#949494',
  corDeFundo: '#F3F3F3',
  corDeFundoBotao: '#4476bf',
  corDaBorda: '#c1c1c1'
}

export default temaLight
